import { productRepository } from "@/modules/product/repositories";
import { Type } from "../type";

export const productUpdateActions = {
  async [Type.PRODUCT_UPDATE_ASYNC]({ commit }, payload) {
    try {
      commit(Type.PRODUCT_LOADING_START);
      const { data } = await productRepository.update(payload);
      commit(Type.PRODUCT_UPDATE_SUCCESS, data?.data);
    } catch (error) {
      commit(Type.PRODUCT_UPDATE_FAILURE, error);
    } finally {
      commit(Type.PRODUCT_LOADING_DONE);
    }
  },
  [Type.PRODUCT_UPDATE_SUCCESS]({ commit }, payload) {},
  [Type.PRODUCT_UPDATE_FAILURE]({ commit }, payload) {},
};
